import axios from "axios";

// #19 - submit a finalized Add State request (after signing). The agent identity
// is sourced server-side from the linked Agent record; we send the request bits
// (states, carriers) and the signing-session id.
const API_URL = "/api/add-state-request";

const request = (addStateRequest) =>
  axios.post(API_URL, { ...addStateRequest }).then((r) => r.data);

const AddStateRequestService = { request };

export default AddStateRequestService;
